<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
          <b-form-input
            v-model="search"
            size="sm"
            class="mr-sm-2"
            placeholder="Chercher par numéro de ticket"
          ></b-form-input>
        </div>
      </div>
    </div>

    <div>
      <base-table
        class="table align-items-center"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="filteredData"
      >
        <template slot="columns">
          <th>Numéro</th>
          <th>Date</th>

          <th>Total</th>
          <th>Mode de paiement</th>

          <th></th>
        </template>

        <template slot-scope="{ row }">
          <td class="budget">{{ row.numero }}</td>
          <td class="budget">{{ $options.filters.date(row.date) }}</td>

          <td>{{ row.total }} DT</td>
          <td>{{ row.selectedPaymentMethod }}</td>
          <td class="text-right">
            <b-button
              size="sm"
              class="mr-2"
              @click="
                getByCodeAndPrint(row.deliverycode, row.total, row.numero)
              "
              >Imprimer reçu</b-button
            >
          </td>
        </template>
      </base-table>
    </div>
    <div v-show="false">
      <CaisseBill :items="data" :total="total" :numero="number" ref="caisse" />
    </div>
    <GStockLoader :loading="loading" />
  </div>
</template>
<script>
import CaisseBill from "@/components/CaisseBillV2";
import GStockLoader from "@/components/Loader";
import { get } from "@/mixins/api";
export default {
  name: "UserTable",
  components: {
    CaisseBill,
    GStockLoader,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      data: [],
      total: "",
      number: 0,
      loading: false,
      tableData: [],
      search: "",
    };
  },
  filters: {
    date: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const tmp = date.toLocaleDateString("fr-FR", { weekday: "long" });
      const day = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      const month = date.toLocaleString("fr-FR", { month: "long" });
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      let currentHour = date.getHours() + "";
      let currentMinute = date.getMinutes() + "";
      if (currentHour.length < 2) currentHour = "0" + currentHour;
      if (currentMinute.length < 2) currentMinute = "0" + currentMinute;
      return (
        day +
        " " +
        dayOfMonth +
        " " +
        month +
        " " +
        year +
        ", " +
        currentHour +
        ":" +
        currentMinute
      );
    },
  },
  computed: {
    filteredData() {
      return this.tableData.filter((x) =>
        (x.numero + "").includes(this.search)
      );
    },
    rows() {
      return this.data.count;
    },
  },

  methods: {
    getByCodeAndPrint(code, total, number) {
      this.loading = true;
      get(`products/${code}/get`)
        .then((res) => {
          this.data = res.data.data;
          this.total = total + "";
          this.number = number;
          setTimeout(() => {
            this.$refs.caisse.printMe();
          }, 1000);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDeliveries() {
      get("delivery").then((response) => {
        this.tableData = response.data.data;
      });
    },
  },
  mounted() {
    this.getDeliveries();
  },
};
</script>
<style>
</style>
